import React from 'react'
import PropTypes from 'prop-types'

import { Text } from 'Components/UI/_Legacy'

import { Container, Item, List } from './styles'

// Deliberately not an accordion. A question heading followed immediately by a
// direct answer is the unit an engine can lift; the same pair nested two
// collapses deep gets skipped.
function KeyQuestions({ items }) {
  if (!items?.length) return null

  return (
    <Container mb={[32, 32, 64]}>
      <Text as="h2" letterSpace={0.5} mb={[24, 24, 32]} medium>
        Common questions
      </Text>

      <List>
        {items.map(item => (
          <Item key={item.id}>
            <Text as="h3" letterSpace={0.5} mb={4} medium>
              {item.question}
            </Text>

            <Text letterSpacing={0.5} light lineHeight={1.71} small>
              {item.answer}
            </Text>
          </Item>
        ))}
      </List>
    </Container>
  )
}

KeyQuestions.defaultProps = {
  items: [],
}

KeyQuestions.propTypes = {
  items: PropTypes.array,
}

export default KeyQuestions
